import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

type ValueType = string | number;


export default /*#__PURE__*/_defineComponent({
  __name: 'TextField',
  props: {
    disabled: { type: Boolean },
    value: null,
    label: { default: 'Name' },
    rules: { default: () => [] },
    leftIcon: null,
    clearable: { type: Boolean },
    rightIcon: null,
    readonly: { type: Boolean },
    type: { default: 'text' },
    errorMessages: null,
    hideDetails: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", value?: ValueType): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { disabled?: boolean, value?: ValueType, label: string, rules: Array<string | boolean | ((value: any) => boolean | string)>, leftIcon?: string, clearable?: boolean, rightIcon?: string, readonly?: boolean, type: string, errorMessages?: string | string[], hideDetails: boolean };



// ensure correct error state when user doesn't input anything
const determineInitialErrorState = () => {
  error.value = props.rules.some((rule) => {
    if (typeof rule === 'function') {
      return typeof rule(selectedItem.value) === 'string';
    } else {
      return typeof rule === 'string' || (typeof rule === 'boolean' && rule);
    }
  });
}

const error = ref(false);

const onError = (value: boolean) => {
  error.value = value;
}



const selectedItem = computed({
  get: () => props.value,
  set: (newValue) => {
    emit('input', newValue);
  }
})



return { __sfc: true,props, determineInitialErrorState, error, onError, emit, selectedItem }
}

})